<template>
  <section>
<!--    switchlogout page-->
  </section>
</template>

<script>

  import { setStore, getStore } from '@/util/store';
  import { AESEncrypt, AESDecrypt } from '@/util/cryptoAES';

  export default {
    name: "switchlogout",
    components: {
    },
    data(){
      return {
        auth: getStore({ name: 'auth' }),
        swithflag: "",
      }
    },
    created() {
      if(this.auth){
        // console.log(this.auth)
        var url = AESDecrypt(this.auth);
        // console.log(url)
        if(url && url.indexOf("http") > -1){
          window.location.replace(url)
        }else{
          this.$router.push('/login');
        }
      }else{
        this.$router.push('/login');
      }
    },
    beforeDestroy() {

    },
    methods: {
      handleSwitch() {
      }
    }
  }
</script>
